import { isNumber } from "lodash";
import RenderOdds from "../matchDetail/RenderOdds";
import useHomeSelectionLogic from "../useLogic/useHomeSelectionLogic";
import { formatWithCommas } from "../../Utils/Toast";

const HomeSelection = ({ object, matchOdds ,outerCondition}) => {
  const {
    runner,
    position,
    localLimit,
    handelChange,
    checkArrays,
    betSlipObject,
    showBetDialog,
  } = useHomeSelectionLogic({ object, matchOdds });
  return (
    <>
      <div className="s-relative">
        <div className="s-space-y-px">
          {runner?.map((item, index) => {
            const odds_back = matchOdds?.rt?.filter(
              (rt) => rt.ib && rt.ri === item.SelectionId,
            );
            const odds_lay = matchOdds?.rt?.filter(
              (todd) => todd.ri === item.SelectionId && !todd.ib,
            );
            const old_back = matchOdds?.rt?.filter(
              (todd) => todd.ib && todd.ri === item.SelectionId,
            );
            const old_lay = matchOdds?.rt?.filter(
              (todd) => !todd.ib && todd.ri === item.SelectionId,
            );
            let disabelBack =
              "lockBackBets" in item ? item?.lockBackBets : false;
            let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;
            let disableFull = checkArrays(
              odds_back?.slice(0, 1),
              odds_lay?.slice(0, 1),
              localLimit,
            );
            let showPosition =
              (position?.betFair?.length > 0 && Math.abs(item?.position) > 0) ||
              (Math.abs(item?.newPosition) >= 0 &&
                showBetDialog &&
                betSlipObject?.playType == "home" &&
                object?.marketId == betSlipObject?.object?.newMarketId);
            return (
              <div>
                <div className="s-flex s-justify-between s-bg-black-100 dark:s-bg-main-block-dark">
                  <div className="s-py-3px s-px-2 s-flex s-flex-1 s-flex-col s-justify-center">
                    <p className="s-text-17px s-font-bold s-leading-120 s-break-all s-text-global-font-default-light dark:s-text-global-font-default-dark">
                      {item?.RunnerName || item?.runnerName}
                    </p>
                    {showPosition && (
                      <div
                        className="s-text-12px s-leading-150 s-flex"
                        data-testid="forecast"
                      >
                        {isNumber(item?.position) &&
                          position?.betFair?.length > 0 &&
                          Math.abs(item?.position) > 0 && (
                            <span
                              className={`s-flex s-items-center s-text-forecast-${
                                item?.position > 0 ? "up" : "down"
                              }-text`}
                              data-testid="estimate-forecast"
                              style={{ marginRight: "4px" }}
                            >
                              {isNumber(item?.position) &&
                              Math.abs(item?.position) > 0
                                ? item?.position > 0
                                  ? Math?.abs(item?.position).toFixed(2)
                                  : `(${Math.abs(item?.position).toFixed(2)})`
                                : ""}
                            </span>
                          )}
                        {Math.abs(item?.newPosition) >= 0 &&
                          showBetDialog &&
                          betSlipObject?.playType == "home" &&
                          object?.marketId ==
                            betSlipObject?.object?.newMarketId && (
                            <span
                              className={`s-flex s-items-center s-text-forecast-${
                                item?.newPosition > 0 ? "up" : "down"
                              }-text`}
                              data-testid="estimate-forecast"
                            >
                              <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                              {item?.newPosition > 0
                                ? Math.abs(item?.newPosition).toFixed(2)
                                : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                            </span>
                          )}
                      </div>
                    )}
                  </div>
                  <RenderOdds
                    component={"betfair"}
                    index={index}
                    item={item}
                    disabelBack={disabelBack}
                    oldBack={old_back}
                    oldLay={old_lay}
                    disableFull={disableFull}
                    disabelLay={object?.eventName == "Indian Premier League" ? true : disabelLay}
                    isInPlay={
                      ["Win", "Winner"].includes(object?.market)
                        ? true
                        : object?.status == "in_play"
                          ? true
                          : false
                    }
                    handelChange={handelChange}
                    odds_lay={odds_lay}
                    odds_back={odds_back}
                    limit={localLimit}
                    ms={matchOdds?.ms || 3}
                    betType={betSlipObject?.betType}
                    active={
                      showBetDialog &&
                      object?.marketId == betSlipObject?.newMarketId &&
                      item?.SelectionId == betSlipObject?.object?.SelectionId &&
                      "home" == betSlipObject?.playType
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>

        {outerCondition && (
          <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
        )}
      </div>
      <div className="s-py-4px s-flex s-justify-between s-items-center s-min-h-30px">
        <div className="s-px-4px s-py-5px s-flex s-gap-3px s-justify-center s-items-center s-rounded s-bg-secondary s-text-global-font-on-dark"></div>
        <div
          className="s-flex s-gap-3px s-items-center s-text-black-600 dark:s-text-black-400"
          data-testid="betLimit"
        >
          <span className="s-icon-min-max s-text-14px" />
          <span className="s-text-12px">Min/Max</span>
          <span className="s-text-12px s-font-bold">
            {formatWithCommas(localLimit?.minAmount)}/
            {formatWithCommas(localLimit?.maxAmount)}
          </span>
        </div>
      </div>
    </>
  );
};

export default HomeSelection;
